import { useQuery } from "@tanstack/react-query";

import { CURRENCIES_QUERY_KEY, QUERY_CACHE_LONG_EXPIRATION_MS } from "@config/query";
import useUserStore from "@store/useUserStore";
import userService from "@services/user.service";

/** Currencies enabled for the active user's organization, ordered with the default first. */
export function useCurrencies() {
  const { activeUser } = useUserStore();
  const organizationId = activeUser?.organization?.id;

  return useQuery({
    queryKey: [CURRENCIES_QUERY_KEY, organizationId],
    queryFn: () => userService.getOrganizationCurrencies(organizationId!),
    staleTime: QUERY_CACHE_LONG_EXPIRATION_MS,
    enabled: !!organizationId,
  });
}
